import AllCsvDownloadsDialog from "./AllCsvDownloadsDialog";
import CsvDownloadsDialog from "./CsvDownloadsDialog";

function RouteAgnosticDialogs() {
  return (
    <>
      <CsvDownloadsDialog kind="analytics" />
      <CsvDownloadsDialog kind="traffic" />
      <AllCsvDownloadsDialog />
    </>
  );
}

export default RouteAgnosticDialogs;
